import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as subrecipients from '../subrecipients'

export const RESOURCE = {
  payload: {
    description:
      'Used to assess the overall risk of a subrecipient for the purpose of subrecipient monitoring',
    dimension: subrecipients.RESOURCE.payload,
    name: 'Subrecipient Risk Assessment',
    partialId: PartialId.Standard.create('subrecipient_risk_survey'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>
